export const GTMDimensions: Record<string, number> = {
  'shipping method': 4,
  'payment method': 5,
  colour: 7,
  hand: 8,
  loft: 9,
  shafttype: 10,
  flex: 11,
  gender: 12,
  'store location': 16,
};

export const GTMMetrics: Record<string, number> = {
  'product discount': 1,
  'discount amount': 2,
  'loyalty points used': 3,
  'loyalty points remaining': 4,
  'customer lifetime value': 5,
  'customer lifetime transactions': 6,
};

/**
 * 
 * account
buyingadvice
category
checkout
club
compare
content
customerservice
error
home
orderconfirmation
plainsite
product
search
storelocator
wishlist
 */

export const Dimension14Mapper: Record<string, string> = {
  account: 'account',
  'pro-golf-advice': 'buyingadvice',
  category: 'category',
  checkout: 'checkout',
  'club-page': 'club',
  compare: 'compare',
  content: 'content',
  support: 'customerservice',
  error: 'error',
  home: 'home',
  'thank-you': 'orderconfirmation',
  plainsite: 'plainsite',
  product: 'product',
  'search-results': 'search',
  'find-stores': 'storelocators',
  wishlist: 'wishlist',
  cart: 'checkout',
};

export default GTMDimensions;
